const environmentSuffix = process.env.ENVIRONMENT !== 'prod' ? `.${process.env.ENVIRONMENT}` : '';
export const media = `media.cocreation${environmentSuffix}.decathlon.net`;

export function getResizedPictureUrl(url: string, pictureFormat?: string) {
  const baseUrl = url?.substring(0, url.lastIndexOf('/') + 1);
  const filename = url?.substring(url.lastIndexOf('/'));
  return baseUrl?.length && filename.length && pictureFormat
    ? `${baseUrl}${pictureFormat}${filename}`
    : url;
};
